import React from "react";
import ParticipCard from "../components/SimulareTraseu/ParticipCard";
import TabelProgram from "../components/SimulareTraseu/TabelProgram";
import ro from "/src/content/ro.json";

const SimulareTraseu = () => {
  return (
    <section id="simulare" className="simulare-container">
      <div className="simulare-content">
        {/* TITLU */}
        <h2 className="simulare-title">{ro.simulare.title}</h2>

        {/* DESCRIERE */}
        <p className="simulare-text">{ro.simulare.description}</p>

        {/* TABEL SIMULARE */}
        <TabelProgram />

        {/* FORMULAR PARTICIPARE */}
        <ParticipCard />

        {/* HARTI */}
        <div className="simulare-harti grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
          {ro.simulare.locations.map((loc) => (
            <div
              className="harta bg-neutral-900 rounded-xl overflow-hidden shadow-lg"
              key={loc.title}
            >
              <h3 className="harta-titlu text-center py-2 text-orange-400 font-semibold">
                {loc.title}
              </h3>

              <iframe
                title={loc.title}
                src={`https://maps.google.com/maps?q=${loc.lat},${loc.lng}&z=16&output=embed`}
                width="100%"
                height="250"
                style={{ border: 0 }}
                loading="lazy"
                allowFullScreen
              ></iframe>

              <div className="flex items-center justify-center gap-2 mt-3 mb-3 text-center">
                <span className="flex items-center gap-1 text-sm text-black">
                  <span className="text-lg">👉</span>
                </span>

                <a
                  href={loc.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-orange-500 underline"
                >
                  {ro.simulare.mapCta}
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SimulareTraseu;
